import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import DefaultContainer from '../../components/DefaultContainer';
import NumberWithCaption from './NumberWithCaption';


const ResponsiveContainer = styled(DefaultContainer)`
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    flex-direction: row;
    align-items: flex-start;
    padding: 75px;
  }
`;

const HandfulOfInformation = () => {
  const theme = useContext(ThemeContext);

  return (
    <ResponsiveContainer backgroundColor={theme.colors.orange}>
      <NumberWithCaption captionText="klientów" number="100+" />
      <NumberWithCaption captionText="wyremontowanych pomieszczeń" number="300+" />
      <NumberWithCaption captionText="lat w branży" number="10+" />
      <NumberWithCaption captionText="położonych farb" number="1000L" />
    </ResponsiveContainer>
  );
};
export default HandfulOfInformation;
